export interface Bonus {
  title: string
  description: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Tennis Ready Warm-Up Games Pack',
    description: '20 games that start any lesson in under 60 seconds.',
    value: 'value $19',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f0568202-7855-4d10-8346-80816f0beb88.jpg',
  },
  {
    title: 'Tennis Rules & Signals Poster Set',
    description:
      ' 14 print-and-hang posters that answer the questions you get asked every week.',
    value: 'value $17',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/995371ce-621d-4543-b6ba-c262d98b3d3a.jpg',
  },
  {
    title: 'Tennis Ready Skill Passport & Certificates',
    description:
      'A 6-level progress booklet your students keep, fill in and bring back.',
    value: 'value $19',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/38961cf9-e77f-41d8-b8fe-356ded501c50.jpg',
  },
  {
    title: 'The 60-Second Sub Plan Pack',
    description: '12 complete sessions anyone can run with no tennis knowledge.',
    value: 'value $17',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dfbde2ce-d35e-4876-bd3c-20778ba50784.jpg',
  },
  {
    title: 'Tennis Ready Home Practice Pack',
    description:
      '40 between-lesson tasks students do alone, with no court and no partner.',
    value: 'value $19',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/011d15a1-1ac7-4272-9034-f1a997409add.jpg',
  },
]
